var _style, _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    width: 100,
    height: 100,
    x: "0px",
    y: "0px",
    viewBox: "0 0 101.5 101.5",
    style: {
      enableBackground: "new 0 0 101.5 101.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_3_);}\n\t.st3{fill:none;stroke:url(#SVGID_4_);stroke-width:1.5;stroke-miterlimit:10;}\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.3423,
    y1: 47.8752,
    x2: 50.3423,
    y2: 69.9566
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05319245,
    style: {
      stopColor: "#A887F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8224E3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.3,26c-13.2,0-24,10.7-24,24c0,13.2,10.7,24,24,24c13.2,0,24-10.7,24-24C74.3,36.7,63.6,26,50.3,26z   M50.3,64.5c-8.1,0-14.6-6.5-14.6-14.6s6.5-14.6,14.6-14.6c8.1,0,14.6,6.5,14.6,14.6S58.4,64.5,50.3,64.5z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.7326,
    y1: 49.9332,
    x2: 64.9521,
    y2: 49.9332
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04078348,
    style: {
      stopColor: "#A887F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9883,
    style: {
      stopColor: "#8224E3"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.3,35.3c-8.1,0-14.6,6.5-14.6,14.6s6.5,14.6,14.6,14.6C58.4,64.5,65,58,65,49.9S58.4,35.3,50.3,35.3z   M50.3,59.8c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8C60.2,55.4,55.8,59.8,50.3,59.8z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.2085,
    y1: 10.7199,
    x2: 84.6822,
    y2: 10.7199
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 5.434346e-7,
    style: {
      stopColor: "#39B54A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D9E021"
    }
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 79.9,
    cy: 10.7,
    r: 4.7
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.8643,
    y1: 86.6357,
    x2: 86.6357,
    y2: 14.8643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000002163083,
    style: {
      stopColor: "#8224E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A887F9",
      stopOpacity: 0
    }
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 50.8,
    cy: 50.8,
    r: 50
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.5132024663556d588d3a9dca5c7fefc8.svg";
export { ForwardRef as ReactComponent };